import { Injectable } from "@angular/core";

@Injectable()
export class CatalogService {

	constructor() { }

	public getCategoryGroupLogo(id: number) {
		const prefix = "/assets/categorygroups/";
		switch (id) {
			case 1: return `${prefix}structural_engineering-default.svg`;
			case 2: return `${prefix}civil_engineering-default.svg`;
			case 3: return `${prefix}electrical-default.svg`;
			case 4: return `${prefix}building_services-default.svg`;
			case 5: return `${prefix}outdoor_facilities-default.svg`;
			case 6: return `${prefix}underground_engineering-default.svg`;
			case 7: return `${prefix}fire_protection-default.svg`;
			case 8: return `${prefix}planning_systems-default.svg`;
			case 9: return `${prefix}safety-and-construction-site-equipment.svg`;
		}
		return undefined;
	}

}
